import { render, staticRenderFns } from "./AssistantMessage.vue?vue&type=template&id=2742c636&scoped=true"
import script from "./AssistantMessage.vue?vue&type=script&lang=js"
export * from "./AssistantMessage.vue?vue&type=script&lang=js"
import style0 from "./AssistantMessage.vue?vue&type=style&index=0&id=2742c636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742c636",
  null
  
)

export default component.exports